import React, { useEffect } from 'react'
import { Table, Image } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { baseSupercargoModel } from '../supercargoModel'
import { ISupercargoDetail } from '../supercargoService'
import { UserDeleteOutlined, FormOutlined } from '@ant-design/icons'
import { Button } from 'antd/lib/radio'
import { getBaseImgLookUrl } from '@/utils/constants'

export function DataTable() {
    const { dataSource, selectedRowKeys, pgCfg, loading, setEditCarVisible, loadData, setSelectedRowKeys, onDelete } = baseSupercargoModel()

    useEffect(() => {
        loadData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const columns: ColumnsType<ISupercargoDetail> = [
        {
            title: '序号',
            width: 60,
            align: 'center',
            render: (t, r, i) => i + 1,
        },
        {
            title: '操作',
            width: 140,
            align: 'center',
            render: (text, record, index) => (
                <>
                    <Button onClick={() => setEditCarVisible({ visible: true, value: { ...record } })}>
                        <FormOutlined style={{ cursor: 'pointer' }} />
                    </Button>
                    <Button onClick={() => onDelete([record])}>
                        <UserDeleteOutlined style={{ cursor: 'pointer' }} />
                    </Button>
                </>
            ),
        },
        {
            title: '姓名',
            width: 120,
            align: 'center',
            dataIndex: 'driverName',
        },
        {
            title: '照片',
            width: 160,
            align: 'center',
            render: (text, records) => (records.md5 ? <Image src={getBaseImgLookUrl(records.md5)} style={{ maxWidth: '50px', maxHeight: '70px' }} /> : null),
        },
        {
            title: '年龄',
            width: 160,
            align: 'center',
            dataIndex: 'driverAge',
        },
        //  {
        //     title: '驾龄',
        //     width: 160,
        //     align: "center",
        //     dataIndex: 'drivingExperience',
        // },
        {
            title: '现住址',
            width: 160,
            align: 'center',
            dataIndex: 'address',
        },
        {
            title: '手机号',
            width: 160,
            align: 'center',
            dataIndex: 'phoneNumber',
        },
        {
            title: '创建人',
            width: 200,
            align: 'center',
            dataIndex: 'createUser',
        },
        {
            title: '所属车队',
            width: 200,
            align: 'center',
            dataIndex: 'fleet',
        },
    ]

    //点击行选高亮
    const onRow = (record: ISupercargoDetail) => {
        let findObj = selectedRowKeys.find((item) => item.id === record.id)
        if (findObj) {
            let newSelectedRowKeys = selectedRowKeys.filter((item) => item.id !== record.id)
            setSelectedRowKeys(newSelectedRowKeys)
        } else {
            setSelectedRowKeys((origin) => [...origin, record])
        }
    }

    return (
        <Table
            rowKey={(record) => record?.id as string}
            loading={loading}
            rowSelection={{
                //全部选中时 (存row[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    selected
                        ? setSelectedRowKeys((origin) => [...origin, ...changeRows])
                        : setSelectedRowKeys((origin) => {
                              let changeRowId = changeRows.map((item) => item.id)
                              return origin.filter((item) => changeRowId.indexOf(item.id) < 0)
                          })
                },
                onSelect: (record, selected, selectedRows) => onRow(record),
                selectedRowKeys: selectedRowKeys.map((item) => item.id as string),
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ['bottomRight'],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                },
                showSizeChanger: true,
            }}
            bordered
            onRow={(record) => ({
                onClick: () => onRow(record),
                onContextMenu: (e) => {
                    e.preventDefault()
                    setSelectedRowKeys([record])
                },
            })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 350px)' }}
        />
    )
}
